import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { ButtonWithSpinner } from '@reveni-io/reveni-ui'

import BankAccountSelector from '@/components/BankAccountSelector'
import AppContext from '@/context/AppContext'
import useBankAccount from '@/hooks/useBankAccount/useBankAccount'
import routes from '@/Router/routes.constants'

import CreateBankAccount from './CreateBankAccount/CreateBankAccount'
import InfoMessage from './InfoMessage/InfoMessage'
import { addExtraNewBankAccountId } from './constants'
import { hasBankAccount, hasNotBankAccount, isFormValid } from './helpers'
import * as Styles from './styles'

const BankAccountStep = ({ onCreateBankAccount }) => {
  const { t } = useTranslation()
  const { context } = useContext(AppContext)
  const [firstName, setFirstName] = useState(context?.orderInfo?.customer_profile?.first_name)
  const [lastName, setLastName] = useState(context?.orderInfo?.customer_profile?.last_name)
  const navigation = useNavigate()

  const {
    bankAccount,
    bankAccounts,
    onChangeBankAccount,
    creatingBankAccount,
    newBankAccount,
    onChangeNewBankAccount,
    newBankAccountError,
    errorType,
    createBankAccount,
  } = useBankAccount()

  const shouldVerifyBankAccount = () => {
    return (
      (bankAccounts?.length > 0 && bankAccount?.id === addExtraNewBankAccountId) ||
      (bankAccounts?.length === 0 && newBankAccount)
    )
  }

  const handleContinue = async () => {
    if (shouldVerifyBankAccount()) {
      await createBankAccount({
        newBankAccount: newBankAccount,
        firstName: firstName,
        lastName: lastName,
        callback: () => onCreateBankAccount(),
      })
    } else {
      navigation(routes.summaryPage)
    }
  }

  return (
    <>
      <InfoMessage orderAmount={context.orderAmount} hasBankAccounts={hasBankAccount(bankAccounts)} />
      {hasBankAccount(bankAccounts) && (
        <BankAccountSelector
          onChangeBankAccount={onChangeBankAccount}
          bankAccounts={context?.bankAccounts}
          selectedAccount={bankAccount?.id}
        />
      )}
      {(hasNotBankAccount(bankAccounts) || bankAccount?.id === addExtraNewBankAccountId) && (
        <CreateBankAccount
          onChange={onChangeNewBankAccount}
          firstName={firstName}
          lastName={lastName}
          onChangeFirstName={setFirstName}
          onChangeLastName={setLastName}
          currency={context.orderAmount?.currency}
          bankAccount={newBankAccount}
          errorType={errorType}
        />
      )}
      <Styles.ActionsContainer>
        <ButtonWithSpinner
          fullWidth
          onClick={() => handleContinue()}
          disabled={
            !isFormValid({
              context,
              firstName,
              lastName,
              bankAccount,
              newBankAccount,
              newBankAccountError,
            }) || creatingBankAccount
          }
          defaultLabel={t('Siguiente')}
          loadingLabel={t('Procesando')}
          loading={creatingBankAccount}
        />
      </Styles.ActionsContainer>
    </>
  )
}

export default BankAccountStep
